export default {
  MOVIES: "MOVIES",
  CURRENT_PAGE: "CURRENT_PAGE",
  TOGGLE_LOADER: "TOGGLE_LOADER",
  REMOVE_MOVIE: "REMOVE_MOVIE",
  TOGGLE_SEARCH: "TOGGLE_SEARCH",
  SHOW_TOAST_NOTIFY: "SHOW_TOAST_NOTIFY",
};
